module.exports = __webpack_public_path__ + "static/media/country_fk.98298746.webp";